import React, {PureComponent} from "react";
import classNames from "classnames";
import styles from "./UIAudioVisualiser.module.scss";

class UIAudioVisualiser extends PureComponent {
  cavasRef: React.RefObject<HTMLCanvasElement>;
  constructor(props : any) {
    super(props);
    this.cavasRef = React.createRef();
  }
  render() {
    //@ts-ignore
    const { playing } = this.props;
    return (
      <div className={styles.Container}>
        <div
          className={classNames({
            [styles.Drop]: true,
            [styles.Animation]: playing,
          })}
          style={{
            width: 56,
            height: 56,
          }}
        ></div>
      </div>
    );
  }
}
//@ts-ignore
UIAudioVisualiser.defaultProps = {
  playing: false,
};
export default UIAudioVisualiser;
